import { render, staticRenderFns } from "./document-sign.vue?vue&type=template&id=6a8addcb&"
import script from "./document-sign.vue?vue&type=script&lang=js&"
export * from "./document-sign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports